import * as React from "react";
import { Row, Col, Input } from "antd";
import styled from "styled-components";
import { RcFile } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";

import { BookPoint } from "../model/BookMultiOrder";
import { Load } from "../../../lib/model/Load";
import { SummaryEntry } from "../../bookDirect/components/SummaryEntry";
import { Address } from "../../../lib/model/Address";
import { numberAsHour } from "../../../lib/formatters";
import DocumentUpload from "../../bookDirect/components/DocumentUpload";
import { renderAddress } from "../../../shared/addressRenderer";

const LoadLabel = styled.span`
  color: #061a32;
  font-size: 11px;
  font-weight: 300;
  display: inline-block;
  margin-top: 12px;
`;

export const StyledInput = styled(Input)`
  height: 40px !important;
  background-color: #f2f2f2 !important;
  border: none !important;
  font-size: 11px !important;
  line-height: 15px !important;
  color: #386ee8 !important;
  font-weight: 300 !important;
  margin-top: 8px !important;
  &::placeholder {
    color: #386ee8 !important;
    font-weight: 300 !important;
  }
`;

type Props = {
  title: string;
  prefix: string;
  point: BookPoint;
  loads?: Load[];
  onChange: (value: BookPoint) => void;
  onEditClick: () => void;
  addresses: Address[];
  handleDocumentBeforeUpload: (file: RcFile, FileList: RcFile[]) => boolean;
  onRemoveDocument: (file: UploadFile) => void;
  documents: RcFile[];
};

export class PointSummaryComponent extends React.Component<Props> {
  render() {
    const {
      title,
      point,
      onChange,
      loads,
      addresses,
      onEditClick,
      handleDocumentBeforeUpload,
      onRemoveDocument,
      documents
    } = this.props;

    return (
      <Row type="flex" style={{ marginBottom: 11 }}>
        <Col span={11}>
          <SummaryEntry
            onEditClick={onEditClick}
            title={title}
            style={{ borderRight: "none" }}
            subTitle={`${numberAsHour(point.timewindow[0])} bis
            ${numberAsHour(point.timewindow[1])} Uhr`}
          >
            <br />
            {renderAddress(point.address, addresses)}
            <br />
            <StyledInput
              placeholder={`${this.props.prefix}referenz (optional)`}
              value={point.comment}
              onChange={value =>
                onChange({
                  ...point,
                  comment: value.currentTarget.value
                })
              }
            />
            <DocumentUpload
              handleBeforeUpload={handleDocumentBeforeUpload}
              onRemove={onRemoveDocument}
              fileList={documents}
              title={`${this.props.prefix}dokumente`}
            />
          </SummaryEntry>
        </Col>
        <Col span={13}>
          <SummaryEntry onEditClick={onEditClick} title="Fracht">
            <Row type="flex">
              {(loads || point.loads).map((load, index) => (
                <Col
                  span={24}
                  style={{ marginBottom: 10 }}
                  key={
                    load.label +
                    load.count +
                    load.totalWeight +
                    load.width +
                    index
                  }
                >
                  <LoadLabel>
                    {load.count} x{" "}
                    {load.customLabel
                      ? `${load.customLabel} `
                      : "" + load.label}
                    <br />
                    {load.length} x {load.width} x {load.height}cm
                    <br />
                    {load.totalWeight}kg Gesamtgewicht
                  </LoadLabel>
                  <br />
                  {loads === undefined && (
                    <StyledInput
                      placeholder="Frachtreferenz (optional)"
                      value={load.internalReference}
                      onChange={event => {
                        const newLoads = [...point.loads];
                        newLoads[index] = {
                          ...load,
                          internalReference: event.target.value
                        };
                        onChange({
                          ...point,
                          loads: newLoads
                        });
                      }}
                    />
                  )}
                </Col>
              ))}
            </Row>
          </SummaryEntry>
        </Col>
      </Row>
    );
  }
}
